import { authenticationService } from '../../services';
import router from '../../router/router';
let user = null;
//const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

const getters = {
    getUserToken: state => {
            return state.user;
    },
    getLoginStatus  : state => {
        return state.status;
    },
    getAccessTokenFromCookie:() =>
    {
        var name = "TokenId=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i<ca.length; i++)
        {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
    },
   
};

export default {
    //name:'Authentication',
    namespaced: true,
    state: {
        initialState,
        IsAuthenticated: false,
        authNRequest : ""
    },
    getters,
    actions: {

        login({ commit }, userClaimsEncrypted) {
            var userClaims = authenticationService.decrypt(userClaimsEncrypted);
            commit('login', { userClaims });
        },

        IsAuthenticated({ commit }) {
            var user = localStorage.getItem("userClaims");
            if (user == null || user.length == 0 || user == "") {
                commit('IsAuthenticated',  false );
            }
            else commit('IsAuthenticated', true);
        },

        getAuthNRequest({ commit }) {
            var authNRequest = authenticationService.getAuthNRequest();
            commit('AuthNRequest', authNRequest);
        },

        logout({ commit }) {
            authenticationService.logout();
            commit('logout');
        },

        unAuthorized({ commit }) {
            commit('unAuthorized', this.state);
        },

        checkAuthentication({ commit })
        {
            if (!this.state.Authentication.user) {
                commit('unAuthorized', this.state);
            }
        }
    },
    mutations: {
        login(state, userClaims) {
            state.userClaims = userClaims;
            localStorage.setItem("userClaims", JSON.stringify(userClaims));
        },
        IsAuthenticated(state, IsAuthenticated) {
            state.IsAuthenticated = IsAuthenticated;
        },
        AuthNRequest(state, authNRequest) {
            state.authNRequest = authNRequest;
        },
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
            state.IsAuthenticated = false;
        },
        unAuthorized(state) {
            state.status = {};
            state.user = null;
            router.push({ name: 'UnAuthorized' });
        }
        
    }
}
